import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { DashboardClComponent } from './dashboard-cl.component';
import { DataDisplayerModule } from 'src/app/components/data-displayer/data-displayer.module';
import { ModeProviderModule } from 'src/app/components/mode-provider/mode-provider.module';
import { ChartModule } from 'src/app/components/data-displayer/chart/chart.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { RangeTableModule } from 'src/app/components/range-table/range-table.module';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EllipsisLoadingComponent } from 'src/app/shared/components/ellipsis-loading/ellipsis-loading.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AttributesReportComponent } from './attributes-report/attributes-report.component';
import { WalletAlertReportComponent } from './wallet-alert-report/wallet-alert-report.component';
import { TabControlComponent } from 'src/app/shared/components/tab-control/tab-control.component';
import { TagComponent } from 'src/app/shared/components/tag/tag.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LocalizedDatePipe } from 'src/app/shared/pipes/localized-date.pipe';
import { GenericTableComponent } from 'src/app/shared/components/generic-table';
import { TableCellDirective } from 'src/app/shared/components/generic-table/directives/table-cell.directive';
import { CpfMaskPipe } from 'src/app/shared/pipes/cpf-mask.pipe';
import { CnpjMaskPipe } from 'src/app/shared/pipes/cnpj-mask.pipe';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [DashboardClComponent, AttributesReportComponent],
  imports: [
    CommonModule,
    DataDisplayerModule,
    ModeProviderModule,
    ChartModule,
    FormsModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatIconModule,
    MatTooltipModule,
    RangeTableModule,
    ReactiveFormsModule,
    SharedModule,
    WalletAlertReportComponent,
    EllipsisLoadingComponent,
    TabControlComponent,
    TagComponent,
    GenericTableComponent,
    TableCellDirective,
    LocalizedDatePipe,
    A11yModule,
  ],
  exports: [DashboardClComponent, LocalizedDatePipe],
  providers: [CpfMaskPipe, CnpjMaskPipe, CurrencyPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DashboardClModule {}
